<template>
  <div>
    <Row type="flex" justify="end" class="code-row-bg">
      <Button class="create_wrong" type="primary" @click="createWrongList">生成错题本</Button>
      <Button class="add_item" icon="md-add" type="primary" @click="modal=true">新建教辅</Button>
    </Row>
    <div class="table">
      <Table border :columns="tables" :data="tableData" ref="table">
        <template slot-scope="{ row }" slot="detail">
          <div>
            <span @click="nvToDetail(row)" style="margin-right:10px;">查看</span>
            <span @click="againProduceImage(row.id)" style="margin-right:10px;">答案图片</span>
            <span @click="deleteItem(row.id)" style="margin-right:10px;">删除</span>
            <span @click="finishModal(row.id) " style="margin-right:10px;">完成</span>
          </div>
        </template>
      </Table>
    </div>
    <Page :total="page.page*10" :current="page.current" @on-change="handlePage" />
    <Modal v-model="modal" title="新建教辅" @on-ok="ok" @on-cancel="cancel" width="332">
      <div class="model-div-select">
        <Input v-model="name" placeholder="请输入教辅名称" style="width: 300px" />
      </div>
      <div class="model-div-select">
        <Select v-model="subject" placeholder="请选择科目" style="width:300px">
          <Option v-for="item in subjectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="model-div-select">
        <Select v-model="className" placeholder="请选择年级" style="width:300px">
          <Option v-for="item in calssList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
    </Modal>
    <Modal v-model="modal1" footer-hide width="500">
      <div class="modal-div">
        <Button class="add_item" size="large" icon="md-add" type="primary" @click="sumbitData">添加pdf</Button>
        <p>上传大文件需要时间，请耐心等待</p>
      </div>
    </Modal>
    <Modal v-model="modal2" footer-hide width="500">
      <div class="modal-div">
        <Button class="add_item" size="large" icon="md-add" type="primary" @click="addExcel">添加EXCEL</Button>
        <p>上传大文件需要时间，请耐心等待</p>
      </div>
    </Modal>
    <Modal v-model="modal3" footer-hide width="500">
      <Table border :columns="tableError" :data="error" ref="table"></Table>
    </Modal>
    <Modal v-model="modal4" width="350" title="提示" @on-ok="finish" @on-cancel="cancel">
      <p style="font-size:20px;">确定完成教辅编辑？</p>
    </Modal>
    <Modal v-model="modal5" width="350" title="提示" @on-ok="deletePaper" @on-cancel="cancel">
      <p style="font-size:20px;">确定删除此教辅？</p>
    </Modal>
  </div>
</template>
<script>
import { Message } from "iview";
import { dealDate, alertTips } from "../common/common.js";
import globalData from "../common/Global.js";
import {
  _papersBooksDotted,
  _papersBooksBoxes,
  _paperBookssTeachersClasses,
  _papersBooks,
  _papersBooksBoxesTemplates,
  _papersBooksBoxesDuplicates,
  _papersBooksBoxesPdf,
  _gitPapersBooks,
  _deletePapers,
  _createWrongList,
  _againProduceImage
} from "../api/api.js";
export default {
  data() {
    return {
      subjectList: [
        {
          value: "语文",
          label: "语文"
        },
        {
          value: "数学",
          label: "数学"
        },
        {
          value: "英语",
          label: "英语"
        }
      ],
      calssList: [
        {
          value: "一年级",
          label: "一年级"
        },
        {
          value: "二年级",
          label: "二年级"
        },
        {
          value: "三年级",
          label: "三年级"
        },
        {
          value: "四年级",
          label: "四年级"
        },
        {
          value: "五年级",
          label: "五年级"
        },
        {
          value: "六年级",
          label: "六年级"
        },
        {
          value: "初一",
          label: "初一"
        },
        {
          value: "初二",
          label: "初二"
        },
        {
          value: "初三",
          label: "初三"
        }
      ],
      tableError: [
        {
          title: "行号",
          align: "center",
          key: "rowNo"
        },
        {
          title: "错误信息",
          align: "center",
          key: "errorInfo"
        }
      ],
      tables: [
        {
          title: "教辅名",
          align: "center",
          key: "name"
        },
        {
          title: "科目",
          align: "center",
          key: "subject"
        },
        {
          title: "年级",
          align: "center",
          key: "grade"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "章节数量",
          align: "center",
          key: "chapterCount"
        },

        {
          title: "EXCEL",
          align: "center",
          render: (h, params) => {
            // if (params.row.status === 4) {
            const arr = [
              {
                text: params.row.excelFile ? "下载" : "生成",
                fn: () => {
                  console.log("下载");
                  _papersBooksBoxesTemplates(params.row.id).then(res => {
                    if (res.code === 0) {
                      console.log(globalData.positdownload + res.data.fileName);

                      window.open(globalData.positdownload + res.data.fileName);
                      this.tableData[params.row.index].excelFile =
                        res.data.fileName;
                    }
                  });
                }
              },
              {
                text: "上传",
                fn: () => {
                  console.log("上传");
                  this.modal2 = true;
                  this.selectId = params.row.id;
                }
              }
            ];
            return h(
              "div",
              arr.map(function(item, index) {
                return h(
                  "span",
                  {
                    style: {
                      marginRight: "20px",
                      color: "#2d8cf0",
                      cursor: "pointer"
                    },
                    on: {
                      click: res => {
                        arr
                          .filter(
                            item => item.text == res.srcElement.innerText
                          )[0]
                          .fn();
                      }
                    }
                  },
                  arr[index].text
                );
              })
            );
            // }
          }
        },
        {
          title: "操作",
          align: "center",
          slot: "detail",
          width: "300",
          className: "fly-blue"
        }
      ],
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      modal5: false,
      subject: "",
      className: "",
      selectIdFinish: "",
      selectIdDelete: "",
      name: "",
      selectId: "",
      tableData: [],
      error: [],
      page: {
        page: 1,
        current: 1
      }
    };
  },
  methods: {
    //    再次生成图片
    againProduceImage(id) {
      const self = this;
      _againProduceImage(id).then(res => {
        if (res.code === 0) {
          alertTips("success", "公式图片成功生成");
        }
      });
    },
    ok() {
      try {
        if (!this.subject) throw "请选择科目";
        if (!this.className) throw "请选择年级";
        if (!this.name) throw "请选择名字";
        _papersBooks({
          name: this.name,
          subject: this.subject,
          grade: this.className
        }).then(res => {
          this.gitPapersBooks();
        });
      } catch (error) {
        Message.error(error);
      }
    },
    //    生成错题本
    createWrongList() {
      const self = this;
      _createWrongList()
        .then(res => {
          if (res.code === 0) {
            alertTips("success", "错题本生成成功");
          } else {
            alertTips("warning", res.message);
          }
        })
        .catch(err => {
          alertTips("error", "网络出小差，请重新生成");
        });
    },
    sumbitData() {
      this.$root.$emit("openUploader", data => {
        _papersBooks({
          name: this.name,
          uri: data.uri,
          size: data.size,
          subject: this.subject,
          grade: this.className
        }).then(res => {
          this.gitPapersBooks();
        });
      });
      this.modal1 = false;
    },
    addExcel() {
      console.log(this.selectId);

      this.$root.$emit("openUploader", data => {
        _papersBooksBoxesDuplicates({
          mode: 0,
          uri: data.uri,
          id: this.selectId
        }).then(res => {
          console.log(res);
          if (res.code === 0) {
            if (res.data.errorCount) {
              this.modal3 = true;
              this.error = res.data.items.map(item => {
                return {
                  errorInfo: item.errorInfo,
                  rowNo: item.rowNo
                };
              });
            } else {
              _papersBooksBoxes({
                id: this.selectId,
                mode: 0,
                uri: data.uri
              }).then(res => {
                if (res.code === 0) {
                  Message.success("成功");
                }
              });
            }
          }
        });
      });
      this.modal2 = false;
    },
    cancel() {},
    gitPapersBooks() {
      _gitPapersBooks(this.page.page - 1).then(res => {
        if (res.code === 0) {
          const { content } = res.data;
          this.page = {
            page: res.data.total / res.data.pageable.size,
            current: res.data.pageable.page + 1
          };
          this.tableData = content.map((item, index) => {
            return {
              name: item.name,
              subject: item.subject,
              grade: item.grade,
              createTime: dealDate(item.createTime),
              status: item.status,
              id: item.id,
              dotFile: item.dotFile,
              dotFileSize: item.dotFileSize
                ? (item.dotFileSize / 1024 / 1024).toFixed(2) + "MB"
                : "",
              excelFile: item.excelFile,
              boxedFile: item.boxedFile,
              chapterCount: item.chapterCount ? item.chapterCount : "",
              index
            };
          });
        }
      });
    },
    paperBookssTeachersClasses(id) {
      _paperBookssTeachersClasses(id).then(res => {
        if (res.code === 0) {
          Message.success("成功");
        }
      });
    },
    finishModal(id) {
      this.modal4 = true;
      this.selectIdFinish = id;
    },
    finish() {
      this.paperBookssTeachersClasses(this.selectIdFinish).then(res => {
        if (res.code === 0) {
          Message.success("成功");
        }
      });
    },
    handlePage(e) {
      this.page.page = e;
      this.gitPapersBooks();
    },
    nvToDetail(e) {
      this.$router.push(
        `/teaching/detail?data=${JSON.stringify({
          id: e.id,
          boxedFile: e.boxedFile
        })}`
      );
    },
    deleteItem(e) {
      this.selectIdDelete = e;
      this.modal5 = true;
    },
    deletePaper() {
      _deletePapers(this.selectIdDelete).then(res => {
        if (res.code === 0) {
          Message.success("成功");
          this.gitPapersBooks();
        }
      });
    }
  },
  created() {
    this.gitPapersBooks();
  }
};
</script>
<style scoped>
.ivu-modal-body {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
}
.table {
  margin: 15px 0 25px 0;
}
.ivu-page {
  display: flex;
  justify-content: center;
}
.create_wrong {
  margin-right: 20px;
}
.modal-div {
  text-align: center;
}
.modal-div p {
  margin-top: 100px;
}
.model-div-select {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Teaching.vue